/**
 * External dependencies
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Internal dependencies
 */
import './styles.scss';

const FormTextInput = (props) => {
    const classes = classNames('form-text-input', props.className, {
        'is-error': props.isError,
        'is-valid': props.isValid,
    });

    return <input type='text' {...props} className={classes} />;
};

FormTextInput.propTypes = {
    isError: PropTypes.bool,
    isValid: PropTypes.bool,
    className: PropTypes.string,
};

export default FormTextInput;
